export enum CblImportResult {
    Fail = 0,
    Partial = 1,
    Success = 2
}